import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["calendarDay", "pasteDayBtn", "pasteWeekBtn", "weekToggleBtn", "holidayTemplate"]

  connect() {
    this.copiedDate = null
    this.copiedWeek = null
    this.restoreClipboard()
    this.fetchHolidays()
  }

  restoreClipboard() {
    try {
      const savedWeek = sessionStorage.getItem('menus_copied_week')
      if (savedWeek) {
        this.copiedWeek = savedWeek
        const weekDate = new Date(savedWeek + 'T00:00:00')
        const weekNumber = this.getWeekNumber(weekDate)
        document.querySelectorAll('.week-paste-btn').forEach((paste_btn) => {
          const baseUrl = paste_btn.dataset.baseUrl
          if (!baseUrl) return
          paste_btn.href = `${baseUrl}&copy=${this.copiedWeek}`
          paste_btn.classList.add('active')
          paste_btn.dataset.copiedWeek = `Semana ${weekNumber}`
        })
      }

      const savedDate = sessionStorage.getItem('menus_copied_date')
      if (savedDate) {
        this.copiedDate = savedDate
        const dateObj = new Date(savedDate + 'T00:00:00')
        const formattedDate = dateObj.toLocaleDateString('es-ES', { day: 'numeric', month: 'short' })
        document.querySelectorAll('.day-paste-btn').forEach((paste_btn) => {
          const baseUrl = paste_btn.dataset.baseUrl
          if (!baseUrl) return
          paste_btn.href = `${baseUrl}&copy=${this.copiedDate}`
          paste_btn.classList.add('active')
          paste_btn.dataset.copiedDate = formattedDate
        })
      }
    } catch (e) {
      console.warn('Could not restore clipboard from sessionStorage', e)
    }
  }

  toggleDayLock(event) {
    // No hacer nada - dejar que Turbo maneje la petición
    // La actualización se hará vía Turbo Stream desde el servidor
  }

  toggleWeekLock(event) {
    // No hacer nada - dejar que Turbo maneje la petición
    // La actualización se hará vía Turbo Stream desde el servidor
  }

  copyDay(event) {
    event.preventDefault();
    const dateStr = event.currentTarget.dataset.date
    
    if (!dateStr) {
      console.error('No date found in copy button')
      return
    }
    
    // Parsear la fecha para mostrar formato amigable
    const dateObj = new Date(dateStr + 'T00:00:00')
    const formattedDate = dateObj.toLocaleDateString('es-ES', { day: 'numeric', month: 'short' })
    
    // Guardar la fecha copiada en formato YYYY-MM-DD
    this.copiedDate = dateStr
    try { sessionStorage.setItem('menus_copied_date', dateStr) } catch (e) {}

    // Actualizar todos los botones de pegar
    const pasteButtons = document.querySelectorAll('.day-paste-btn')
    pasteButtons.forEach((paste_btn) => {
      const baseUrl = paste_btn.dataset.baseUrl
      paste_btn.href = `${baseUrl}&copy=${this.copiedDate}`
      paste_btn.classList.add('active')
      paste_btn.dataset.copiedDate = formattedDate
    })
    
    // Marcar el botón de copiar como activo
    const copyButtons = document.querySelectorAll('.day-copy-btn')
    copyButtons.forEach((btn) => {
      btn.classList.remove('active')
    })
    event.currentTarget.classList.add('active')
    
    // Feedback visual: mostrar notificación
    this.showCopyNotification(`Día ${formattedDate} copiado`)
  }

  copyWeek(event) {
    event.preventDefault();
    const weekStr = event.currentTarget.dataset.week
    
    if (!weekStr) {
      console.error('No week found in copy button')
      return
    }
    
    // Parsear la fecha para calcular el número de semana
    const weekDate = new Date(weekStr + 'T00:00:00')
    const weekNumber = this.getWeekNumber(weekDate)
    
    // Guardar la semana copiada en formato YYYY-MM-DD
    this.copiedWeek = weekStr
    try { sessionStorage.setItem('menus_copied_week', weekStr) } catch (e) {}

    // Actualizar todos los botones de pegar
    const pasteButtons = document.querySelectorAll('.week-paste-btn')
    pasteButtons.forEach((paste_btn) => {
      const baseUrl = paste_btn.dataset.baseUrl
      paste_btn.href = `${baseUrl}&copy=${this.copiedWeek}`
      paste_btn.classList.add('active')
      paste_btn.dataset.copiedWeek = `Semana ${weekNumber}`
    })
    
    // Marcar el botón de copiar como activo
    const copyButtons = document.querySelectorAll('.week-copy-btn')
    copyButtons.forEach((btn) => {
      btn.classList.remove('active')
    })
    event.currentTarget.classList.add('active')
    
    // Feedback visual: mostrar notificación
    this.showCopyNotification(`Semana ${weekNumber} copiada`)
  }

  showCopyNotification(message) {
    // Crear o actualizar notificación
    let notification = document.getElementById('copy-notification')
    if (!notification) {
      notification = document.createElement('div')
      notification.id = 'copy-notification'
      notification.className = 'copy-notification'
      document.body.appendChild(notification)
    }
    
    notification.textContent = message
    notification.classList.add('show')
    
    setTimeout(() => {
      notification.classList.remove('show')
    }, 2000)
  }

  getWeekNumber(date) {
    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
    const dayNum = d.getUTCDay() || 7
    d.setUTCDate(d.getUTCDate() + 4 - dayNum)
    const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1))
    return Math.ceil((((d - yearStart) / 86400000) + 1) / 7)
  }

  addDaySpinner(event) {
    const dayCell = event.currentTarget.closest("td.day-cell") || event.currentTarget.closest("td.day-menus");
    if (dayCell) {
      // Agregar overlay con spinner en lugar de reemplazar todo el contenido
      let overlay = dayCell.querySelector('.day-spinner-overlay');
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 'day-spinner-overlay';
        overlay.innerHTML = `
          <div class="spinner-border text-success spinner-border-sm" role="status">
            <span class="sr-only">Cargando...</span>
          </div>
        `;
        dayCell.style.position = 'relative';
        dayCell.appendChild(overlay);
      }
      
      // Desactivar botones mientras carga
      const pasteBtn = event.currentTarget;
      pasteBtn.style.pointerEvents = 'none';
      pasteBtn.style.opacity = '0.6';
    }
  }

  addWeekSpinners(event) {
    // Desactivar botones mientras carga
    const pasteBtn = event.currentTarget;
    pasteBtn.style.pointerEvents = 'none';
    pasteBtn.style.opacity = '0.6';
    
    // Agregar spinner al contenedor de la semana
    const weekCell = event.currentTarget.closest('.week-cell');
    if (weekCell) {
      let overlay = weekCell.querySelector('.week-spinner-overlay');
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 'week-spinner-overlay';
        overlay.innerHTML = `
          <div class="spinner-border text-success spinner-border-sm" role="status">
            <span class="sr-only">Cargando...</span>
          </div>
        `;
        weekCell.style.position = 'relative';
        weekCell.appendChild(overlay);
      }
    }
  }

  fetchHolidays() {
    const month = parseInt(this.element.dataset.month)
    const year = parseInt(this.element.dataset.year) || new Date().getFullYear()
    
    if (!month || isNaN(month)) {
      console.error('Invalid month value:', month)
      return
    }
    
    fetch(`/menus/holidays?year=${year}`)
      .then(async response => {
        if (!response.ok) {
          const errorText = await response.text()
          console.error('Server response:', errorText)
          throw new Error(`HTTP error! status: ${response.status}, body: ${errorText}`)
        }
        return response.json()
      })
      .then(data => {
        if (!data || !Array.isArray(data) || data.length === 0) {
          console.warn('No holiday data available')
          return
        }
        
        const monthData = data[month - 1]
        if (!monthData) {
          console.warn(`No holiday data available for month ${month}`)
          return
        }
        
        const holidayTemplate = this.holidayTemplateTarget
        
        Object.entries(monthData).forEach(([day, holidays]) => {
          if (!Array.isArray(holidays)) {
            holidays = [holidays]
          }
          
          holidays.forEach((dayInfo) => {
            if (!dayInfo || !dayInfo.motivo) {
              console.warn('Invalid holiday data:', dayInfo)
              return
            }
            
            const content = holidayTemplate.innerHTML
              .replace(/TEMPLATE_ID/g, new Date().valueOf())
              .replace(/MOTIVO/g, dayInfo.motivo)
            
            const selectedCalendarDay = this.calendarDayTargets.find((calendarDay) => {
              const calendarDayMonth = parseInt(calendarDay.dataset.month)
              const calendarDayDay = parseInt(calendarDay.dataset.day)
              return calendarDayDay === parseInt(day) && calendarDayMonth === month
            })
            
            if (selectedCalendarDay) {
              selectedCalendarDay.insertAdjacentHTML('beforeend', content)
            }
          })
        })
      })
      .catch(error => {
        console.error('Error fetching holidays:', error)
        console.error('Error details:', error.stack)
      })
  }
}